import { LAYOUT } from '@admin/router/constant'

// 拓色相关单据
const expandColorRouter = {
  path: '/expandColorDevelopment',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: '/expand-color-decision/index',
      name: 'expandColorDecisionList',
      component: () =>
        import('@admin/views/plm/expandColorDevelopment/expandColorDecisionList/index.vue'),
      meta: { helpUrl: '', title: '拓色开发决策单' },
    },
    {
      path: '/expand-color-decision/detail',
      name: 'expandColorDecisionDetail',
      component: () => import('@admin/views/plm/newDesign/detail/index.vue'),
      meta: { helpUrl: '', title: '拓色开发决策单详情' },
    },
    {
      path: '/expand-color-design/index',
      name: 'expandColorDesignList',
      component: () =>
        import('@admin/views/plm/expandColorDevelopment/expandColorDesignList/index.vue'),
      meta: { helpUrl: '', title: '拓色设计' },
    },
    {
      path: '/expand-color-design/detail',
      name: 'expandColorDesignDetail',
      component: () => import('@admin/views/plm/newDesign/detail/index.vue'),
      meta: { helpUrl: '', title: '拓色设计详情' },
    },
    {
      path: '/fob-expand-color-sample/index',
      name: 'fobExpandColorSampleList',
      component: () =>
        import('@admin/views/plm/expandColorDevelopment/fobExpandColorSampleList/index.vue'),
      meta: { helpUrl: '', title: 'FOB拓色样板开发单' },
    },
    {
      path: '/fob-expand-color-sample/detail',
      name: 'fobExpandColorSampleDetail',
      component: () => import('@admin/views/plm/newDesign/detail/index.vue'),
      meta: { helpUrl: '', title: 'FOB拓色样板开发单详情' },
    },
    {
      path: '/expand-figure-sample/index',
      name: 'expandFigureSampleList',
      component: () =>
        import('@admin/views/plm/expandColorDevelopment/expandFigureSampleList/index.vue'),
      meta: { helpUrl: '', title: '拓身形样板开发单' },
    },
    {
      path: '/expand-figure-sample/detail',
      name: 'expandFigureSampleDetail',
      component: () => import('@admin/views/plm/newDesign/detail/index.vue'),
      meta: { helpUrl: '', title: '拓身形样板开发单详情' },
    },
  ],
}

export default expandColorRouter
